module.exports = __webpack_public_path__ + "static/img/15.bc61046b.jpg";